import { useCallback, type RefObject } from 'react';
import type { CameraRef } from '@maplibre/maplibre-react-native';

import { getUserCoordinates } from '../utils/geolocation';
import { INITIAL_ZOOM } from '../utils/mapConfig';

export const useFocusOnCurrentLocation = (cameraRef: RefObject<CameraRef | null>) => {
  const focusOnCurrentLocation = useCallback(async () => {
    try {
      const coordinates = await getUserCoordinates();

      if (!coordinates) {
        return;
      }

      cameraRef.current?.flyTo({
        center: [coordinates.longitude, coordinates.latitude],
        zoom: INITIAL_ZOOM,
        duration: 1500,
      });
    } catch {
      // Silently ignore failures to retrieve the user's location.
    }
  }, [cameraRef]);

  return focusOnCurrentLocation;
};